if (!customElements.get('wlsn-product-faq-tabs')) {
    class WLSNProductFaqTabs extends HTMLElement {
        constructor() {
            super();

            this.tabs = this.querySelectorAll('.js-wlsn-product-faq-tab');
            this.contentGroups = this.querySelectorAll(
                '.wlsn-product-faq-tabs__content-group'
            );
        }

        connectedCallback() {
            this.initProductTabs();
            this.initInnerTabs();
        }

        initProductTabs() {
            this.tabs.forEach((tab) => {
                tab.addEventListener('click', () => {
                    const tabIndex = tab.dataset.tabIndex;

                    this.tabs.forEach((item) =>
                        item.classList.remove('is-active')
                    );

                    this.contentGroups.forEach((group) =>
                        group.classList.remove('is-active')
                    );

                    tab.classList.add('is-active');

                    const activeGroup = this.querySelector(
                        `.wlsn-product-faq-tabs__content-group[data-tab-index="${tabIndex}"]`
                    );

                    activeGroup?.classList.add('is-active');

                    activeGroup?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
            });
        }

        initInnerTabs() {
            const groups = this.querySelectorAll(
                '.wlsn-product-faq-tabs__content-group'
            );

            groups.forEach((group) => {
                const buttons = group.querySelectorAll(
                    '.js-wlsn-product-faq-tabs-content-groups-inner-tab'
                );

                const panels = group.querySelectorAll(
                    '.wlsn-product-faq-tabs__content-groups-inner-content-faq'
                );

                buttons.forEach((button) => {
                    button.addEventListener('click', () => {
                        const index = button.dataset.btnIndex;

                        buttons.forEach((btn) =>
                            btn.classList.remove('is-active')
                        );

                        panels.forEach((panel) =>
                            panel.classList.remove('is-active')
                        );

                        button.classList.add('is-active');

                        const activePanel = group.querySelector(
                            `.wlsn-product-faq-tabs__content-groups-inner-content-faq[data-faq-index="${index}"]`
                        );

                        activePanel?.classList.add('is-active');
                    });
                });
            });
        }
    }

    customElements.define('wlsn-product-faq-tabs', WLSNProductFaqTabs);
}